import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';

import { IncomingPlusProductsResult } from './ingest';
import { PlusEnvironment } from './environment';
import { TradeAlertProductData, TradeAlertVideos } from './entities';

export class PlusRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(PlusEnvironment).url, session, { 'x-device-key': false });
  }
  getProducts = (): SafePromise<IncomingPlusProductsResult> => {
    const url = this.URL('products');
    return this.debouncedGet(url, { credentials: 'include' });
  };

  getProductData = (product: string): SafePromise<TradeAlertProductData> => {
    const url = this.URL(`table/public/${product}`, {
      token: this.session.getEnvironment(PlusEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getProductVideos = (product: string): SafePromise<TradeAlertVideos> => {
    const url = this.URL(`videos/public/${product}`, {
      token: this.session.getEnvironment(PlusEnvironment).token,
    });
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
